import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import './gimbil.scss';
import gimbilLogo from './img/gimbil_logo_light.svg'
import { GIMBIL_URL } from '../../../config/constants';

export default function GimbilPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Gimbil Mobile')
	}, [pageTitle]);

	return (
		<React.Fragment>

			<div className={'content-block gimbil-page'}>
				<div className='dx-card wide-card'>
					<div className={'gimbil-info'}>
						<div><img src={gimbilLogo}></img></div>
						<div className={'description'}>The website that assists CFI's for all their appointments.</div>
						<div><a href={GIMBIL_URL} target="_blank" >Go to the Website</a></div>
						<div><a href={'https://countertops.cld.bz/Gimbil-App-User-Guide'} target="_blank" >View Training</a></div>
					</div>
					<div className={'gimbil-mobile'}>
						<div className="back-mobile" />
						<div className="front-mobile" />
					</div>
				</div>

			</div>
		</React.Fragment>
	)
} 
